import { render, staticRenderFns } from "./LandwirtschaftPage.vue?vue&type=template&id=b3ad849e&"
import script from "./LandwirtschaftPage.vue?vue&type=script&lang=js&"
export * from "./LandwirtschaftPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports